// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { TableTotalsVisibility } from '../../cache/TableTotalsVisibility';
export class QuickTableColumn {
    constructor() {
        // main
        this.width = 100;
        this.headerText = 'Header';
        this.visible = true;
        this.hidden = false;
        this.allowSorting = true;
        this.allowGrouping = false;
        this.displayedIndex = 1;
        this.alignment = QTAlignment.Left;
        // Colors
        this.BackColor = null;
        this.color = null;
        this.ForeColor = null;
        this.beginGroup = false;
        this.MenuIndex = 1000;
        //
        // Private fields (прячем в специальном объекте)
        //
        this.PRIVATE = {};
        this.ColouringMode = ColouringModes.None;
        this.leftPadding = undefined;
        this.rightPadding = undefined;
        this.PRIVATE.drawingWidth = 0;
        this.PRIVATE.drawingX = 0;
    }
    setParameters(columnParams) {
        this.headerText = Resources.getResource(columnParams.headerKey);
        this.headerKey = columnParams.headerKey;
        this.visible = columnParams.visible;
        this.hidden = columnParams.hidden;
        this.allowGrouping = columnParams.allowGrouping;
        this.sortIndex = columnParams.sortIndex;
        this.displayedIndex = columnParams.sortIndex;
        this.width = columnParams.width;
        // this.sortRule = columnParams.sortRule;
        this.beginGroup = columnParams.beginGroup;
        this.MenuIndex = columnParams.MenuIndex;
        const tooltipKey = this.headerKey + '.descr';
        this.tooltipKey = Resources.IsResourcePresent(tooltipKey) ? tooltipKey : this.headerKey;
    }
    isShowTotal() {
        return (this.totalsVisibility & TableTotalsVisibility.Overall) !== 0;
    }
    isShowGroupTotal() {
        return (this.totalsVisibility & TableTotalsVisibility.Groups) !== 0;
    }
}
export var ColouringModes;
(function (ColouringModes) {
    ColouringModes[ColouringModes["None"] = 0] = "None";
    ColouringModes[ColouringModes["Previous"] = 1] = "Previous";
    ColouringModes[ColouringModes["Signed"] = 2] = "Signed";
})(ColouringModes || (ColouringModes = {}));
export var QTAlignment;
(function (QTAlignment) {
    QTAlignment["Left"] = "Left";
    QTAlignment["Center"] = "Center";
    QTAlignment["Right"] = "Right";
})(QTAlignment || (QTAlignment = {}));
